































import Vue, { PropType } from 'vue'
import ticketBackground from '../images/ticket-base.svg'
import { loadConfig, getDefaultConfig, AppConfig } from '../config'

interface Stamp {
  stamp_id: number,
  pos: [number, number]
  rot: number
}

interface Ticket {
  name: string
  ticket_id?: string
  country_code?: string
  stamps: Stamp[]
}

export default Vue.extend({
  name: 'ticket-preview',
  props: {
    ticket: {
      type: Object as PropType<Ticket>,
      required: true
    }
  },
  watch: {
    ticket() {
      this.$nextTick(this.updateNameSize)
    }
  },
  data() {
    return {
      ticketBackground,
      config: getDefaultConfig() as AppConfig,
      name_size: 15,
      tid_size: 15,
    }
  },
  computed: {
    ticket_id(): string {
      if (!this.ticket.ticket_id) {
        return 'HAYA2-EX-****-****-**'
      }
      if (!this.ticket.country_code) {
        return this.ticket.ticket_id
      }
      return `${this.ticket.ticket_id}-${this.ticket.country_code}`
    }
  },
  async mounted() {
    // 設定を非同期で読み込む
    this.config = await loadConfig()
    this.$nextTick(this.updateNameSize)
  },
  methods: {
    getStampImage(stamp_id: number): string {
      const filename = this.config.stampFilenames[stamp_id] || this.config.stampFilenames[2]
      return `${this.config.stampBasePath}/part${stamp_id}/${filename}`
    },
    updateNameSize(): void {
      if (this.$refs.name) {
        const rect = (this.$refs.name as SVGTextElement).getBBox()
        if (190 < rect.width) {
          this.name_size = 15 * 190 / rect.width
        }
      }
    }
  }
})
